import Task from "../task";

export const MAX_DURATION_DAYS = 365 * 10 // 10 years


export default function taskSetCalendarDuration(task:Task, value:number|null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (value === 0) {
        task.updateStartDate(null)
        return;
    }

    if (value > MAX_DURATION_DAYS) value = MAX_DURATION_DAYS

    const startDate = task.startDate ? task.startDate : momentDate()
    const endDate   = moment(startDate).add(value-1,'days')

    task.updateStartEnd(startDate, endDate)
}


